module.exports = {
	allowedLanguages: ['en', 'it'],
	defaultLanguage: 'en'
};
